import { Injectable } from '@angular/core';
import { Observable, tap, map, catchError, of } from 'rxjs';
import { PreferenciaColorService } from './preferencia-color.service';
import { TemaService } from './tema.service';

export interface DatosSelectorColor {
  colorActual: string;
  coloresOcupados: Map<string, string>;
}

@Injectable({
  providedIn: 'root'
})
export class ServicioPreferenciaColorRol {
  constructor(
    private readonly preferenciaColorService: PreferenciaColorService,
    private readonly temaService: TemaService
  ) {}

  public obtenerDatosSelector(rol: string): DatosSelectorColor {
    return {
      colorActual: this.preferenciaColorService.obtenerColorPorRol(rol) ?? '',
      coloresOcupados: this.preferenciaColorService.obtenerColoresOcupados()
    };
  }

  public guardarYAplicarColor(rol: string, codigoColor: string, esRolActivo: boolean): Observable<boolean> {
    return this.preferenciaColorService.guardarPreferencia(rol, codigoColor).pipe(
      tap(() => {
        if (esRolActivo) {
          this.temaService.aplicarColorPersonalizado(codigoColor);
        }
      }),
      map(() => true),
      catchError(() => of(false))
    );
  }

  public guardarColorLocal(rol: string, codigoColor: string, esRolActivo: boolean): void {
    this.preferenciaColorService.upsertLocal(rol, codigoColor);
    if (esRolActivo) {
      this.temaService.aplicarColorPersonalizado(codigoColor);
    }
  }

  public obtenerColoresOcupados(): Map<string, string> {
    return this.preferenciaColorService.obtenerColoresOcupados();
  }

  public cargarPreferencias(): Observable<unknown> {
    return this.preferenciaColorService.cargarPreferencias();
  }

  public obtenerColorPorRol(rol: string): string | null {
    return this.preferenciaColorService.obtenerColorPorRol(rol);
  }
}
